<template>
  <div
    ref="valueRef"
    v-tooltip="tooltip"
    class="ui-asset-name"
  >
    <slot>{{ name }}</slot>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, useTemplateRef } from 'vue'
import { useResizeObserver } from '@vueuse/core'
import { Placement } from 'floating-vue'

type Props = {
  name?: string
  tooltipPlacement?: Placement
}

const { name, tooltipPlacement = 'top' } = defineProps<Props>()

const valueRef = useTemplateRef('valueRef')
const isValueEllipsis = ref(false)

const tooltip = computed(() => {
  if (!isValueEllipsis.value) return
  return {
    placement: tooltipPlacement,
    content: name,
    handleResize: true,
  }
})

useResizeObserver(valueRef, () => {
  if (!valueRef.value || !name) return
  isValueEllipsis.value = 
    valueRef.value.offsetWidth < valueRef.value.scrollWidth || 
    valueRef.value.offsetHeight < valueRef.value.scrollHeight
})
</script>
